import { render } from "./FileCard.vue?vue&type=template&id=5dcfb776&scoped=true"
import script from "./FileCard.vue?vue&type=script&lang=js"
export * from "./FileCard.vue?vue&type=script&lang=js"

import "./FileCard.vue?vue&type=style&index=0&id=5dcfb776&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcfb776"]])

export default __exports__